// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=TODO

import { Icon } from '~/components'

export default function ChangeButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-[25px] h-[25px] pl-[7px]"
    >
      <Icon id="pen" />
    </button>
  )
}
